import { FC } from "react";
import styles from "./history-report.module.scss";
import { IVDPBlockData, IVDPPageBlock, VDPBlockPosition } from "../../../types/vdp";
import { VehicleType } from "../../../types/vehicle";
import { getTranslationModule } from "../../../utils/translations";
import VDPSection from "@/ui/page-components/vehicle-details-page/vdp-section";

interface ICarfaxHistoryReportConfig {
  partnerId: string;
}

const CarfaxHistoryReport: FC<IVDPPageBlock> = ({ vdpGlobalData, config, translations }) => {
  const t = getTranslationModule(translations, "vdp");

  const vehicle = vdpGlobalData.vehicle;
  const VIN = vehicle?.vin;
  const carfaxConfig: ICarfaxHistoryReportConfig = config;

  return vehicle.type !== VehicleType.NEW ? (
    <VDPSection title={t("history_report")}>
      <a
        className={styles.content}
        target="_blank"
        rel="noreferrer noopener"
        href={`http://www.carfax.com/cfm/ccc_DisplayHistoryRpt.cfm?partner=${carfaxConfig.partnerId}&vin=${VIN}`}
      >
        <span className={styles.linkText}>{t("click_history_report")}</span>
        <img src="/images/carfax_logo.svg" alt="Carfax" width={104} height={27} />
      </a>
    </VDPSection>
  ) : null;
};

const VDPBlockData: IVDPBlockData = {
  component: (props: IVDPPageBlock, key: any) => (
    <CarfaxHistoryReport
      key={key}
      config={props.config}
      siteData={props.siteData}
      pageContext={props.pageContext}
      renderingPosition={props.renderingPosition}
      vdpGlobalData={props.vdpGlobalData}
      translations={props.translations}
    />
  ),
  position: VDPBlockPosition.LEFT,
};

export default VDPBlockData;
